/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var __ol__ = _interopDefault(require('openlayers'));
var imageSource = _interopDefault(require('../mixin/image-source'));
var withUrl = _interopDefault(require('../mixin/with-url'));
var vueHelpers = require('../util/vue-helpers');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

/**
 * @vueProps
 */
var ImageStaticSource = __ol__.source.ImageStatic;
var props = /** @lends module:image-static-source/source# */{
  /**
   * Image extent in the source projection.
   * @type {ol.Extent|number[]}
   */
  extent: {
    type: Array,
    required: true,
    validator: function validator(value) {
      return value.length === 4;
    }
  },
  /**
   * Optional function to load an image given a URL.
   * @type {function|undefined}
   */
  loadFunc: Function,
  /**
   * Image size in pixels.
   * @type {ol.Size|number[]}
   */
  size: {
    type: Array,
    validator: function validator(value) {
      return value.length === 2;
    }
  },
  /**
   * Image URL.
   * @type {string}
   */
  url: {
    type: String,
    required: true,
    validator: function validator(value) {
      return !!value.length;
    }
  }

  /**
   * @vueMethods
   */
};var methods = /** @lends module:image-static-source/source# */{
  /**
   * @return {ol.source.ImageStatic}
   * @protected
   */
  createSource: function createSource() {
    return new ImageStaticSource({
      attributions: this.attributions,
      crossOrigin: this.crossOrigin,
      imageExtent: this.extent,
      imageLoadFunction: this.loadFunc,
      logo: this.logo,
      projection: this.projection,
      imageSize: this.size,
      url: this.urlTmpl
    });
  }
};

var watch = vueHelpers.makeWatchers(_Object$keys(props), function () {
  return function () {
    this.scheduleRecreate();
  };
});

/**
 * A layer source for displaying a single, static image.
 *
 * @vueProto
 * @title vl-source-image-static
 * @alias module:image-static-source/source
 */
var Source = {
  name: 'vl-source-image-static',
  mixins: [imageSource, withUrl],
  props: props,
  methods: methods,
  watch: watch
};

/**
 * @alias module:image-static-source
 */
var index = {
  /**
   * A layer source for displaying a single, static image.
   * @alias module:image-static-source/source
   */
  Source: Source,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/image-static-source/index.js
// module id = 1465
// module chunks = 1